import Vue from 'vue'
import Router from 'vue-router'
// 主页引导页
const Index = resolve => require(['@/views/Home/Index/Index'], resolve)
// 首页
const Home = resolve => require(['@/views/Home/Index/Home'], resolve)
// 首页推荐信用卡列表页
const HostCard = resolve => require(['@/views/Home/Index/HostCard'], resolve)
// 活动页
const Activity = resolve => require(['@/views/Home/Activity/Index'], resolve)
// 活动细则页
const ActivityRules = resolve => require(['@/views/Home/Activity/ActivityRules'], resolve)
// 测试内容页
const Content = resolve => require(['@/views/Home/Index/Content'], resolve)
// 登录
const Login = resolve => require(['@/views/Login/Login/Login'], resolve)
// 注册1
const registerA = resolve => require(['@/views/Login/Register/registerA'], resolve)
// 注册2
const registerB = resolve => require(['@/views/Login/Register/registerB'], resolve)
// 手机绑定
const mobileBinding = resolve => require(['@/views/Login/MobileBinding/mobileBinding'], resolve)
// 手机绑定重置密码
const MobileresetPassword = resolve => require(['@/views/Login/MobileBinding/MobileresetPassword'], resolve)
// 忘记密码
const forgotPassword = resolve => require(['@/views/Login/ForgotPassword/forgotPassword'], resolve)
// 重置密码
const resetPassword = resolve => require(['@/views/Login/ForgotPassword/resetPassword'], resolve)
// 分享
// 分享首页
const ShareIndex = resolve => require(['@/views/Share/ShareIndex/Index'], resolve)
// 专题栏位页
const ChannelIndex = resolve => require(['@/views/Share/ShareIndex/Channel'], resolve)
// 作者页
const AuthorIndex = resolve => require(['@/views/Share/ShareIndex/Author'], resolve)
// 添加好友备注页
const addRemarks = resolve => require(['@/views/Share/ShareIndex/addRemarks'], resolve)
// 新增文章页
const AddArticle = resolve => require(['@/views/Share/Article/AddArticle'], resolve)
// 文章详情页
const ArticleDetails = resolve => require(['@/views/Share/Article/ArticleDetails'], resolve)
// 发表评论页
const Comment = resolve => require(['@/views/Share/Article/Comment'], resolve)
// 其他用户中心页
const OtherUserPages = resolve => require(['@/views/Share/OtherUserPages/OtherUserPages'], resolve)
// 用户中心
// 用户中心首页
const UserIndex = resolve => require(['@/views/UserCenter/UserIndex/Index'], resolve)
// 联系客服页
const Customer = resolve => require(['@/views/UserCenter/UserIndex/Customer'], resolve)
// 设置页
const SetUpIndex = resolve => require(['@/views/UserCenter/SetUp/Index'], resolve)
// 设置页-重置密码
const setPassword = resolve => require(['@/views/UserCenter/SetUp/setPassword'], resolve)
// 重置支付密码
const setPayPassword = resolve => require(['@/views/UserCenter/SetUp/setPayPassword'], resolve)
// 重置登录密码
const setLoginPassword = resolve => require(['@/views/UserCenter/SetUp/setLoginPassword'], resolve)
// 再次输入密码页面
const setSecLoginPassword = resolve => require(['@/views/UserCenter/SetUp/setSecLoginPassword'], resolve)
// 设置新密码页面
const setNewLoginPassword = resolve => require(['@/views/UserCenter/SetUp/setNewLoginPassword'], resolve)
// 不记得支付密码
const setPayPasswordFoget = resolve => require(['@/views/UserCenter/SetUp/setPayPasswordFoget'], resolve)
// 短信验证码输入多次之后，跳转到图片验证码页面
const setPayPasswordFoget1 = resolve => require(['@/views/UserCenter/SetUp/setPayPasswordFoget1'], resolve)
// 输入身份证号码验证页面
const setShotMessageValidate = resolve => require(['@/views/UserCenter/SetUp/setShotMessageValidate'], resolve)
// 记得支付密码
const setPayPasswordRember1 = resolve => require(['@/views/UserCenter/SetUp/setPayPasswordRember1'], resolve)
//  重新设置支付密码
const setPayPasswordRember2 = resolve => require(['@/views/UserCenter/SetUp/setPayPasswordRember2'], resolve)
// 再次输入种重置的密码
const setPayPasswordRember3 = resolve => require(['@/views/UserCenter/SetUp/setPayPasswordRember3'], resolve)
// 意见反馈页
const OpinionFeedback = resolve => require(['@/views/UserCenter/SetUp/OpinionFeedback'], resolve)
// 关于我们页
const AboutUs = resolve => require(['@/views/UserCenter/SetUp/AboutUs'], resolve)
// 个人信息页
const PersonalInfo = resolve => require(['@/views/UserCenter/MyInfo/Index'], resolve)
// 昵称修改页
const NicknameModify = resolve => require(['@/views/UserCenter/MyInfo/NicknameModify'], resolve)
// 签名修改页
const SignatureModify = resolve => require(['@/views/UserCenter/MyInfo/SignatureModify'], resolve)
// 性别修改页
const SexModify = resolve => require(['@/views/UserCenter/MyInfo/SexModify'], resolve)
// 年龄修改页
const ageModify = resolve => require(['@/views/UserCenter/MyInfo/ageModify'], resolve)
// 个人信息修改页
const MyselfModify = resolve => require(['@/views/UserCenter/MyInfo/MyselfModify'], resolve)
// 房产信息修改页
const PropertyModify = resolve => require(['@/views/UserCenter/MyInfo/PropertyModify'], resolve)
// 房产信息维护修改页
const PropertyManageModify = resolve => require(['@/views/UserCenter/MyInfo/PropertyManageModify'], resolve)
// 房产信息新增页面
const PropertyAdd = resolve => require(['@/views/UserCenter/MyInfo/PropertyAdd'], resolve)
// 车产信息修改页
const CarModify = resolve => require(['@/views/UserCenter/MyInfo/CarModify'], resolve)
// 车产信息维护修改页
const CarManageModify = resolve => require(['@/views/UserCenter/MyInfo/CarManageModify'], resolve)
// 车产信息新增页面
const CarInfoAdd = resolve => require(['@/views/UserCenter/MyInfo/CarInfoAdd'], resolve)
// 金融信息-登陆密码验证页
const FinancialVerification = resolve => require(['@/views/UserCenter/FinancialInfor/Index'], resolve)
// 实名认证页
const RealName = resolve => require(['@/views/UserCenter/RealName/Index'], resolve)
// 扫描页
const RealScanning = resolve => require(['@/views/UserCenter/RealName/Scanning'], resolve)
// 详细地址地图选择页
const AddressMap = resolve => require(['@/views/UserCenter/RealName/AddressMap'], resolve)
// 我的文章列表页
const MyArticleList = resolve => require(['@/views/UserCenter/MyList/Index'], resolve)
// 我的收藏列表页
const MyCollectionList = resolve => require(['@/views/UserCenter/MyList/CollectionList'], resolve)
// 我的关注列表页
const MyConcernsList = resolve => require(['@/views/UserCenter/MyList/ConcernsList'], resolve)
// 我的粉丝列表页
const MyFanList = resolve => require(['@/views/UserCenter/MyList/FanList'], resolve)
// 我的银行卡列表页
const MyBankCardList = resolve => require(['@/views/UserCenter/MyBankCard/Index'], resolve)
// 添加银行卡页A
const AddBankCardA = resolve => require(['@/views/UserCenter/MyBankCard/AddBankCardA'], resolve)
// 添加银行卡页B
const AddBankCardB = resolve => require(['@/views/UserCenter/MyBankCard/AddBankCardB'], resolve)
// 添加银行卡页C
const AddBankCardC = resolve => require(['@/views/UserCenter/MyBankCard/AddBankCardC'], resolve)
// 添加银行卡页D
const AddBankCardD = resolve => require(['@/views/UserCenter/MyBankCard/AddBankCardD'], resolve)
// 公司税号列表页
const CompanyTaxList = resolve => require(['@/views/UserCenter/CompanyTax/Index'], resolve)
// 公司添加税号页
const CompanyAddDuty = resolve => require(['@/views/UserCenter/CompanyTax/AddDuty'], resolve)
// 公司税号详情页
const CompanyDetails = resolve => require(['@/views/UserCenter/CompanyTax/Details'], resolve)
// 公司税号编辑页
const CompanyEdit = resolve => require(['@/views/UserCenter/CompanyTax/Edit'], resolve)
// 公司税号扫一扫页
const CompanyScan = resolve => require(['@/views/UserCenter/CompanyTax/Scan'], resolve)
// 系统通知页
const SystemNotice = resolve => require(['@/views/UserCenter/Notice/Index'], resolve)
// 动态通知页
const DynamicNotice = resolve => require(['@/views/UserCenter/Notice/DynamicNotice'], resolve)
// 网申
// 网申卡银行选择列表页
const NetCardSelectList = resolve => require(['@/views/OnlineApplication/ApplicationCard/Index'], resolve)
// 网申卡产品选择列表页
const NetCardProductList = resolve => require(['@/views/OnlineApplication/ApplicationCard/ProductList'], resolve)
// 网申卡详情页
const NetCardDetails = resolve => require(['@/views/OnlineApplication/ApplicationCard/Details'], resolve)
// 网申卡评价列表
const NetCardEvaluate = resolve => require(['@/views/OnlineApplication/ApplicationCard/Evaluate'], resolve)
// 申卡信息填写页A
const NetCardInfoFillingA = resolve => require(['@/views/OnlineApplication/ApplicationCard/InfoFillingA'], resolve)
// 申卡信息填写页B
const NetCardInfoFillingB = resolve => require(['@/views/OnlineApplication/ApplicationCard/InfoFillingB'], resolve)
// 申卡信息填写页C
const NetCardInfoFillingC = resolve => require(['@/views/OnlineApplication/ApplicationCard/InfoFillingC'], resolve)
// 申卡完成页
const NetCardInfoFillingD = resolve => require(['@/views/OnlineApplication/ApplicationCard/InfoFillingD'], resolve)
// 申请须知
const NetCardNoticeA = resolve => require(['@/views/OnlineApplication/ApplicationCard/NoticeA'], resolve)
// 领用合约
const NetCardNoticeB = resolve => require(['@/views/OnlineApplication/ApplicationCard/NoticeB'], resolve)
// 申请人声明
const NetCardNoticeC = resolve => require(['@/views/OnlineApplication/ApplicationCard/NoticeC'], resolve)
// 芝麻信用协议
const NetCardNoticeD = resolve => require(['@/views/OnlineApplication/ApplicationCard/NoticeD'], resolve)
// 进度查询申请列表页
const ScheduleQueryList = resolve => require(['@/views/OnlineApplication/ScheduleQuery/Index'], resolve)
// 进度查询结果详情页
const QueryResultsDetails = resolve => require(['@/views/OnlineApplication/ScheduleQuery/ResultsDetails'], resolve)
// 进度查询银行列表页
const QueryBankCardList = resolve => require(['@/views/OnlineApplication/ScheduleQuery/BankCardList'], resolve)
// 申请评价列表页
const EvaluateList = resolve => require(['@/views/OnlineApplication/Evaluate/Index'], resolve)
// 申请评价录入页
const EvaluateEntry = resolve => require(['@/views/OnlineApplication/Evaluate/Entry'], resolve)
// 申请评价详情页
const EvaluateDetails = resolve => require(['@/views/OnlineApplication/Evaluate/Details'], resolve)
// 理财
// 理财产品列表页
const ConductFinList = resolve => require(['@/views/ConductFinTran/Index'], resolve)
// 错误页
const Error = resolve => require(['@/views/Common/error'], resolve)
// 积分商城
// 积分安全检查页
const SecurityCheck = resolve => require(['@/views/IntegralMall/Index'], resolve)
// 商品列表页
const GoodsList = resolve => require(['@/views/IntegralMall/List/Index'], resolve)
// 券包列表页
const CouponList = resolve => require(['@/views/IntegralMall/List/Coupon'], resolve)
// 用户中心订单列表页
const OrderList = resolve => require(['@/views/IntegralMall/Order/Index'], resolve)
// 评价列表页(预留)
const EvaluationList = resolve => require(['@/views/IntegralMall/Order/EvaluationList'], resolve)
// 订单详情页
const OrderDetails = resolve => require(['@/views/IntegralMall/Details/Index'], resolve)
// 订单发表评价页
const PubEvaluation = resolve => require(['@/views/IntegralMall/Details/Evaluation'], resolve)
// 下载页
const Download = resolve => require(['@/views/Home/Index/Download'], resolve)

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      meta: {
        title: ''
      }
    }, {
      path: '/Home',
      component: Home,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/HostCard',
      component: HostCard,
      meta: {
        title: '信用卡'
      }
    }, {
      path: '/Activity/Index',
      component: Activity,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Error',
      component: Error,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Activity/ActivityRules',
      component: ActivityRules,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Index/Content/:id',
      component: Content,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/Login',
      component: Login,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/register/registerA',
      component: registerA,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/registerB/:loginId',
      component: registerB,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/MobileBinding/MobileBinding',
      component: mobileBinding,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/MobileBinding/MobileresetPassword/:mobile',
      component: MobileresetPassword,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/ForgotPassword/forgotPassword/:mobile',
      component: forgotPassword,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/Login/ForgotPassword/resetPassword/:mobile',
      component: resetPassword,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/ShareIndex/Index',
      component: ShareIndex,
      meta: {
        title: '分 享',
        keepAlive: true
      }
    }, {
      path: '/ShareIndex/Channel',
      component: ChannelIndex,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/ShareIndex/Author/:authId',
      component: AuthorIndex,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/ShareIndex/addRemarks/:authId/:nickName',
      component: addRemarks,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/Article/AddArticle',
      component: AddArticle,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/Article/ArticleDetails/:id',
      component: ArticleDetails,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/Article/Comment',
      component: Comment,
      meta: {
        title: '分 享'
      }
    }, {
      path: '/OtherUserPages/OtherUserPages',
      component: OtherUserPages,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/UserIndex/Index',
      component: UserIndex,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/UserIndex/Customer',
      component: Customer,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/UserCenter/SetUp/Index',
      component: SetUpIndex,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPassword',
      component: setPassword,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPassword',
      component: setPayPassword,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setLoginPassword',
      component: setLoginPassword,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setSecLoginPassword/:oldPwd/:pwd',
      component: setSecLoginPassword,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setNewLoginPassword/:oldPwd',
      component: setNewLoginPassword,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPasswordFoget',
      component: setPayPasswordFoget,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPasswordFoget1',
      component: setPayPasswordFoget1,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setShotMessageValidate',
      component: setShotMessageValidate,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPasswordRember1',
      component: setPayPasswordRember1,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPasswordRember2',
      component: setPayPasswordRember2,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/setPayPasswordRember3/:Pwd',
      component: setPayPasswordRember3,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/OpinionFeedback',
      component: OpinionFeedback,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/SetUp/AboutUs',
      component: AboutUs,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/Index',
      component: PersonalInfo,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/NicknameModify/:nickName',
      component: NicknameModify,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/SignatureModify/:signature',
      component: SignatureModify,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/ageModify/:age',
      component: ageModify,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/SexModify',
      component: SexModify,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/MyselfModify',
      component: MyselfModify,
      meta: {
        title: '用户中心'
      }
    }, {
      path: '/MyInfo/PropertyModify',
      component: PropertyModify,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyInfo/PropertyManageModify',
      component: PropertyManageModify,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyInfo/PropertyAdd',
      component: PropertyAdd,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyInfo/CarModify',
      component: CarModify,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyInfo/CarManageModify',
      component: CarManageModify,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyInfo/CarInfoAdd',
      component: CarInfoAdd,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/FinancialInfor/Index',
      component: FinancialVerification,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/RealName/Scanning/:cid',
      component: RealScanning,
      meta: {
        title: '实名认证'
      }
    }, {
      path: '/RealName/Index/:cid',
      component: RealName,
      meta: {
        title: '实名认证'
      }
    }, {
      path: '/RealName/AddressMap',
      component: AddressMap,
      meta: {
        title: '伴 儿'
      }
    }, {
      path: '/MyList/MyArticleList',
      component: MyArticleList,
      meta: {
        title: '我的文章'
      }
    }, {
      path: '/MyList/CollectionList',
      component: MyCollectionList,
      meta: {
        title: '我的收藏'
      }
    }, {
      path: '/MyList/ConcernsList',
      component: MyConcernsList,
      meta: {
        title: '我的关注'
      }
    }, {
      path: '/MyList/FanList',
      component: MyFanList,
      meta: {
        title: '我的粉丝'
      }
    }, {
      path: '/MyBankCard/Index',
      component: MyBankCardList,
      meta: {
        title: '我的银行卡'
      }
    }, {
      path: '/MyBankCard/AddBankCardA',
      component: AddBankCardA,
      meta: {
        title: '添加银行卡'
      }
    }, {
      path: '/MyBankCard/AddBankCardB/:card',
      component: AddBankCardB,
      meta: {
        title: '添加银行卡'
      }
    }, {
      path: '/MyBankCard/AddBankCardC/:card/:mobile/:isPic',
      component: AddBankCardC,
      meta: {
        title: '添加银行卡'
      }
    }, {
      path: '/MyBankCard/AddBankCardD',
      component: AddBankCardD,
      meta: {
        title: '我的银行卡'
      }
    }, {
      path: '/CompanyTax/Index',
      component: CompanyTaxList,
      meta: {
        title: '公司税号'
      }
    }, {
      path: '/CompanyTax/AddDuty',
      component: CompanyAddDuty,
      meta: {
        title: '添加税号'
      }
    }, {
      path: '/CompanyTax/Details/:dId',
      component: CompanyDetails,
      meta: {
        title: '税号详情'
      }
    }, {
      path: '/CompanyTax/Edit/:id',
      component: CompanyEdit,
      meta: {
        title: '修改税号'
      }
    }, {
      path: '/CompanyTax/Scan/:dId',
      component: CompanyScan,
      meta: {
        title: '公司税号'
      }
    }, {
      path: '/Notice/Index',
      component: SystemNotice,
      meta: {
        title: '消 息'
      }
    }, {
      path: '/Notice/DynamicNotice',
      component: DynamicNotice,
      meta: {
        title: '消 息'
      }
    }, {
      path: '/ApplicationCard/Index',
      component: NetCardSelectList,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/ProductList/:bankId',
      component: NetCardProductList,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/Details/:id',
      component: NetCardDetails,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/Evaluate/:id',
      component: NetCardEvaluate,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/InfoFillingA/:id',
      component: NetCardInfoFillingA,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/InfoFillingB/:id',
      component: NetCardInfoFillingB,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/InfoFillingC/:id',
      component: NetCardInfoFillingC,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/InfoFillingD',
      component: NetCardInfoFillingD,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/NoticeA',
      component: NetCardNoticeA,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/NoticeB',
      component: NetCardNoticeB,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/NoticeC',
      component: NetCardNoticeC,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ApplicationCard/NoticeD',
      component: NetCardNoticeD,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ScheduleQuery/Index',
      component: ScheduleQueryList,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ScheduleQuery/ResultsDetails/:id',
      component: QueryResultsDetails,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/ScheduleQuery/BankCardList',
      component: QueryBankCardList,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/Evaluate/Index',
      component: EvaluateList,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/Evaluate/Entry/:id',
      component: EvaluateEntry,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/Evaluate/Details/:id',
      component: EvaluateDetails,
      meta: {
        title: '信用卡网申'
      }
    }, {
      path: '/Conduct/Index/:id',
      component: ConductFinList,
      meta: {
        title: '理财推荐'
      }
    }, {
      path: '/Security/Index/:typeId/:baner',
      component: SecurityCheck,
      meta: {
        title: ''
      }
    }, {
      path: '/List/Index/:baner',
      component: GoodsList,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/List/Coupon/:baner',
      component: CouponList,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/Order/Index/:typeId/:baner',
      component: OrderList,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/Order/EvaluationList',
      component: EvaluationList,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/Details/Index/:id',
      component: OrderDetails,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/Details/Evaluation/:orderNo/:goodId',
      component: PubEvaluation,
      meta: {
        title: '积券通'
      }
    }, {
      path: '/Download',
      component: Download,
      meta: {
        title: ''
      }
    }],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js